import * as React from 'react';
import classnames from 'classnames';

import { Link } from 'libs/router';

import Tooltip from 'components/Tooltip';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { expandDataProps } from 'utils/helper/common';

import './add-new.scss';

import type { Data, SVGDynamicIconCustomColor } from 'types';

import type { SyntheticEvent } from 'react';

type Icon = {
  name: string,
  width: number,
  height: number,
  distance?: 'single' | 'double'
};

type Props = {
  text?: string,
  size?: 'normal' | 'large' | 'xlarge' | 'small',
  icon?: Icon,
  color?: SVGDynamicIconCustomColor,
  link?: string,
  tooltip?: string,
  openModal?: boolean,
  data?: Data,
  onClick?: (a: SyntheticEvent<any>) => void
};

class AddNew extends React.PureComponent<Props> {
  static defaultProps = {
    openModal: false,
    color: 'primary',
    size: 'normal'
  };

  renderItem(): React.ReactNode {
    const { text, icon, color } = this.props;
    const iconDistance = icon && icon.distance ? icon.distance : 'single';

    const iconClasses = classnames('add-new__icon', {
      [`add-new__icon--distance-${iconDistance}`]: Boolean(iconDistance)
    });

    return (
      <React.Fragment>
        {
          icon && (
            <div className={iconClasses}>
              <SVGDynamicIcon
                name={icon.name}
                width={icon.width}
                height={icon.height}
                customColor={color}
              />
            </div>
          )
        }
        {
          text && (
            <div className="add-new__text">
              {text}
            </div>
          )
      }
      </React.Fragment>
    );
  }

  renderContents(): React.ReactNode {
    const { link, openModal } = this.props;

    if (link && !openModal) {
      return (
        <Link to={link}>
          {this.renderItem()}
        </Link>
      );
    }

    return this.renderItem();
  }

  render(): React.ReactNode {
    const { text, icon, tooltip, data, color, size, onClick } = this.props;

    const containerClasses = classnames('add-new', {
      [`add-new--${String(color)}`]: Boolean(color),
      [`add-new--size-${String(size)}`]: Boolean(size)
    });

    if (!text && !icon) {
      return null;
    }

    return (
      <div
        className={containerClasses}
        onClick={onClick}
        {...expandDataProps(data)}
      >
        {
          tooltip ?
            <Tooltip
              message={tooltip}
              width="auto-compact"
            >
              {this.renderContents()}
            </Tooltip> :
            this.renderContents()
        }
      </div>
    );
  }
}

export default AddNew;
